import React, { useState } from "react";
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "@/components/ui/dialog";
import { ScrollArea } from "@/components/ui/scroll-area";
import { X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { VersionSelector } from "./legal/VersionSelector";
import { GUIDELINES_VERSIONS } from "./legal/types";
import { GuidelinesV1_0 } from "./legal/versions/guidelines/GuidelinesV1_0";

interface CommunityGuidelinesModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const CommunityGuidelinesModal: React.FC<CommunityGuidelinesModalProps> = ({ open, onOpenChange }) => {
  const [selectedVersion, setSelectedVersion] = useState('1.0');

  const renderVersionContent = () => {
    switch (selectedVersion) {
      case '1.0':
        return <GuidelinesV1_0 />;
      default:
        return <GuidelinesV1_0 />;
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="!fixed !inset-0 !left-0 !top-0 !translate-x-0 !translate-y-0 !m-0 !w-screen !h-screen !max-w-none !max-h-none !p-0 !bg-white !border-none !rounded-none">
        <div className="flex flex-col h-full min-h-0">
          <header className="fixed left-0 right-0 top-0 z-50 bg-white border-b border-gray-200 px-4 sm:px-6 py-6">
            <div className="flex items-center justify-between gap-4 sm:gap-6">
              <DialogTitle className="text-xl sm:text-2xl font-bold text-gray-900 uppercase flex-1 leading-tight">
                Diretrizes da Comunidade - Interlaced
              </DialogTitle>
              <Button
                variant="ghost"
                size="icon"
                className="flex-shrink-0 h-10 w-10 sm:h-12 sm:w-12 rounded-full bg-red-600 text-white hover:bg-red-700 hover:text-white transition-colors"
                onClick={() => onOpenChange(false)}
                aria-label="Fechar"
              >
                <X className="h-5 w-5 sm:h-6 sm:w-6" />
              </Button>
            </div>
            <DialogDescription className="sr-only">
              Leia as diretrizes completas da comunidade Interlaced
            </DialogDescription>
          </header>
        
          {/* Scrollable content with custom scrollbar */}
          <ScrollArea className="flex-1 min-h-0 pt-modal-content">
            {renderVersionContent()}
            
            {/* Version selector in footer */}
            <VersionSelector
              versions={GUIDELINES_VERSIONS}
              currentVersion={selectedVersion}
              onVersionChange={setSelectedVersion}
            />
          </ScrollArea>
        </div>
      </DialogContent>
    </Dialog>
  );
};